import ParentClass from './Parent.js';

class Partner extends ParentClass {
  constructor() {
    super();
    const moduleClass = '.partner';
    if (!super.runThisModule(moduleClass)) return;

    this.handleClose();
  }

  handleClose() {
    const logo = $('.component-partner_list .logo');
    const close = $('.component-partner_list .close');

    close.click(function (e) {
      e.preventDefault();
      $(this).closest('.body').css('display', 'none');
      $(this).parents('.partner').find('.logo').css('display', 'block');
    });

    logo.click(function (e) {
      e.preventDefault();
      $(this).parents('.partner').find('.body').css('display', 'block');
      $(this).css('display', 'none');
    });
  }
}

jQuery(document).ready(function() {
  new Partner();
});



// WEBPACK FOOTER //
// ./wp-content/themes/variscale/library/js/classes/Partner.js